<script setup lang="ts">
import logo from '@/assets/FHBC-logo.svg'

const copyrightYear = new Date().getFullYear()
</script>
<template>
  <v-container class="footer">
    <v-row>
      <v-col cols="12" sm="3" class="site-info-md-start">
        <span class="align-center">
          <span class="d-none d-lg-inline d-xl-inline"
            ><img :src="logo" alt="logo" class="footer-logo" /><br />&copy;&nbsp;{{ copyrightYear
            }}<br />
          </span>
          <span class="d-inline d-lg-none d-xl-none">
            604.737.3146&nbsp;(t)<br />604.873.6488&nbsp;(f)
            <br />
            <a href="https://fieldhockeybc.com/about/contact-us/" target="_blank" rel="noopener">
              Contact Emails
            </a>
          </span>
        </span>
      </v-col>
      <v-col cols="12" sm="9" class="site-info-container text-center">
        <span>
          7455&nbsp;132nd&nbsp;St.,&nbsp;Suite&nbsp;101<br />Surrey, BC,
          <br class="d-none d-lg-inline d-xl-inline" />
          V3W&nbsp;1J8
          <span class="d-inline d-lg-none d-xl-none"><br />&copy;&nbsp;{{ copyrightYear }}</span>
        </span>
        <span class="d-none d-lg-inline d-xl-inline">
          604.737.3146&nbsp;(t)<br />604.873.6488&nbsp;(f)<br />
          <a href="https://fieldhockeybc.com/about/contact-us/" target="_blank" rel="noopener">
            Contact Emails
          </a>
        </span>
      </v-col>
    </v-row>
  </v-container>
</template>
<style lang="scss" scoped>
.footer {
  font-size: 12px;
  .footer-logo {
    width: 50px;
    height: auto;
  }
  a {
    color: #ffffff;
    text-decoration: none;
    &:hover {
      text-decoration: underline;
    }
  }
}

.site-info-container,
.site-info-md-start {
  span {
    line-height: 1.5em;
  }
}

.site-info-md-start {
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  @media (max-width: 599px) {
    width: 100%;
    align-items: center;
  }
}

.site-info-container {
  display: flex;
  gap: 1rem;
  align-items: center;
  justify-content: right;

  @media (max-width: 599px) {
    flex-direction: column;
    gap: 0;
    align-items: center;
  }
}

/* Custom media query for screens smaller than 400px */
// Shrink vertical spacing for mobile
@media (max-width: 768px) {
  .v-col {
    padding-top: 4px !important;
    padding-bottom: 4px !important;
  }

  .footer {
    font-size: 11px;
    line-height: 1.3;
  }

  .footer-logo {
    width: 35px;
  }

  .v-row {
    row-gap: 4px;
  }

  span,
  a {
    display: inline-block;
    line-height: 1.4;
  }
}

// Override Vuetify's default spacing for the mobile stack
@media (max-width: 425px) {
  .v-row {
    margin-left: 0;
    margin-right: 0;
  }

  .v-col {
    padding-left: 0 !important;
    padding-right: 0 !important;
    text-align: center !important;
  }
}
</style>
